import { AnyAction } from 'redux';
import { ActionTypes } from './actions';
import ApplicationVersion from './ApplicationVersion';

export interface State {
	currentBuild: string | null;
	availableVersion: ApplicationVersion | null;
}

function createState(): State {
	return {
		currentBuild: null,
		availableVersion: null,
	};
}

export default function reducer(state: State = createState(), action: AnyAction): State {
	switch (action.type) {
		case ActionTypes.receive:
			return { ...state, availableVersion: action.version };

		default:
			return state;
	}
}

export function hasApplicationUpdate(state: State): boolean {
	const { currentBuild, availableVersion } = state;
	return Boolean(availableVersion && availableVersion.build !== currentBuild);
}
